import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { cryptoTokenDecode, checkObjExists } from "../Common/Common";
import * as message from "../../config/CommonMessages";
import { Upload, QrCode2, Save } from "@mui/icons-material";
import { Clear, Send } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";

class FormFooter extends React.Component {
  constructor(props) {
    let currentType = localStorage.getItem("currentRole");
    let userType = cryptoTokenDecode().usertype;
    super(props);
    this.state = {
      userType: userType.toUpperCase(),
      userRole: !!currentType ? currentType.toUpperCase() : "",
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  findFormErrors = () => {
    const newErrors = {};
    let trans = this.props.transaction;
    if (trans) {
      if (!trans.clientFirstName || trans.clientFirstName.trim() === "") {
        newErrors.clientFirstName = message.ENTER_FIRST_NAME;
      }
      if (trans.clientFirstName) {
        if (!trans.clientFirstName.match("^[A-Za-z '-]{1,50}$")) {
          newErrors.clientFirstName = message.ENTER_VALID_FIRST_NAME;
        }
      }
      if (trans.clientLastName) {
        if (!trans.clientLastName.match("^[A-Za-z '-]{1,50}$")) {
          newErrors.clientLastName = message.ENTER_VALID_LAST_NAME;
        }
      }
      if (trans.clientEmail) {
        if (
          !trans.clientEmail.match(
            "^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
          )
        ) {
          newErrors.clientEmail = message.ENTER_VALID_EMAIL;
        }
      }
      if (trans.clientPhone) {
        let clientMobile = trans.clientPhone.replace(/-/g, "");
        if (clientMobile.length !== 10) {
          newErrors.clientPhone = message.ENTER_VALID_MOBILE;
        }
      }
      if (trans.hasGuardian) {
        if (!trans.guardianName || trans.guardianName.trim() === "") {
          newErrors.guardianName = message.ENTER_NAME;
        }
        if (trans.guardianName) {
          if (!trans.guardianName.match("^[A-Za-z '-]{1,50}$")) {
            newErrors.guardianName = message.ENTER_VALID_NAME;
          }
        }
        if (trans.guardianEmail) {
          if (
            !trans.guardianEmail.match(
              "^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
            )
          ) {
            newErrors.guardianEmail = message.ENTER_VALID_EMAIL;
          }
        }
        if (trans.guardianPhone) {
          let guardianMobile = trans.guardianPhone.replace(/-/g, "");
          if (guardianMobile.length !== 10) {
            newErrors.guardianPhone = message.ENTER_VALID_MOBILE;
          }
        }
      }
    }
    return newErrors;
  };

  render() {
    let btnTitle = "";
    let btnName = "";
    if (this.props.formType && this.props.formType === "intake") {
      btnTitle = "Save & Open Consent Form";
      btnName = "uploadAndOpenConsent";
    }
    if (this.props.formType && this.props.formType === "consent") {
      btnTitle = "Save & Open Intake Form";
      btnName = "uploadAndOpenIntake";
    }
    return (
      <div className="mb-5">
        <Row>
          <Col xs={12} sm={7} className="sticky-header-buttons-mobile">
            <Tooltip placement="bottom" title="Upload form">
              <Button
                name="upload"
                variant="primary"
                className="text-uppercase sticky-header-btn mr-2"
                onClick={() => {
                  const newErrors = this.findFormErrors();
                  if (checkObjExists(newErrors)) {
                    this.props.errorHandler(newErrors);
                  } else {
                    this.props.errorHandler(newErrors);
                    this.props.handleShowPrompt("upload");
                  }
                }}
                disabled={!checkObjExists(this.props.transaction)}
                style={
                  !checkObjExists(this.props.transaction)
                    ? { backgroundColor: "gray", borderColor: "gray" }
                    : {}
                }
              >
                <Upload />
              </Button>
            </Tooltip>
            {this.props.formType && this.props.formType === "checkin" ? (
              ""
            ) : this.state.userType !== message.BUYER &&
              this.state.userRole !== message.BUYER ? (
              <Tooltip placement="bottom" title="Send form">
                <Button
                  name="send"
                  variant="primary"
                  className="text-uppercase sticky-header-btn mr-2"
                  onClick={() => this.props.handleShowPrompt("send")}
                  disabled={
                    !checkObjExists(this.props.transaction)
                      ? true
                      : !this.props.selectedTransClientEmail
                      ? true
                      : false
                  }
                  style={
                    !checkObjExists(this.props.transaction)
                      ? { backgroundColor: "gray", borderColor: "gray" }
                      : !this.props.selectedTransClientEmail
                      ? { backgroundColor: "gray", borderColor: "gray" }
                      : {}
                  }
                >
                  <Send />
                </Button>
              </Tooltip>
            ) : (
              ""
            )}
            {this.props.formType &&
            (this.props.formType === "intake" ||
              this.props.formType === "consent" ||
              this.props.formType === "checkin") ? (
              <Tooltip placement="bottom" title="Generate QR Code">
                <Button
                  name="upload"
                  variant="primary"
                  className="text-uppercase sticky-header-btn mr-2"
                  onClick={() => this.props.handleShowQRcodePrompt()}
                  disabled={!checkObjExists(this.props.transaction)}
                  style={
                    !checkObjExists(this.props.transaction)
                      ? { backgroundColor: "gray", borderColor: "gray" }
                      : {}
                  }
                >
                  <QrCode2 />
                </Button>
              </Tooltip>
            ) : (
              ""
            )}

            <Tooltip placement="bottom" title={btnTitle}>
              <Button
                name={btnName}
                variant="primary"
                className="text-uppercase sticky-header-btn mr-2"
                onClick={() => {
                  const newErrors = this.findFormErrors();
                  if (checkObjExists(newErrors)) {
                    this.props.errorHandler(newErrors);
                  } else {
                    this.props.errorHandler(newErrors);
                    this.props.handleShowPrompt(btnName);
                  }
                }}
                disabled={!checkObjExists(this.props.transaction)}
                style={
                  !checkObjExists(this.props.transaction)
                    ? { backgroundColor: "gray", borderColor: "gray" }
                    : {}
                }
              >
                <Save />
              </Button>
            </Tooltip>

            <Tooltip placement="bottom" title="Clear artwork">
              <Button
                name="clear"
                variant="primary"
                className="text-uppercase sticky-header-btn"
                onClick={(e) => this.props.handleShowPrompt("clear")}
                disabled={!checkObjExists(this.props.transaction)}
                style={
                  !checkObjExists(this.props.transaction)
                    ? { backgroundColor: "gray", borderColor: "gray" }
                    : {}
                }
              >
                <Clear />
              </Button>
            </Tooltip>
          </Col>
        </Row>
      </div>
    );
  }
}

export default FormFooter;
